import script from "./SearchPensions.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchPensions.vue?vue&type=script&setup=true&lang=js"

import "./SearchPensions.vue?vue&type=style&index=0&id=3f5ed735&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f5ed735"]])

export default __exports__